import { createUseStyles } from 'react-jss';
import { ITheme, mediaQuery } from '@quicktools/shared-components';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    '@global': {
      '*': {
        margin: 0,
        padding: 0,
        boxSizing: 'border-box',
      },
      body: {
        background: 'var(--x-bg-5)',
        overflowX: 'hidden',
      },
      '-webkit-overflow-scrolling': 'touch',

      '.lfta-landing': {
        paddingTop: 40,
      },
      '.lfta-main-container': {
        paddingBottom: 32,
      },
      '.link--underline': {
        textDecoration: 'underline',
        color: 'inherit',
      },

      [mediaQuery(breakpoints.tablet)]: {
        paddingTop: 0,
      },
    },

    layout: {
      '& .lfta-content-siderbar': {
        top: 274,
      },
    },

    hidden: {
      display: 'none',
    },

    editor: {
      position: 'fixed',
      insetInlineEnd: 40,
      zIndex: 106,

      [mediaQuery(breakpoints.tablet)]: {
        insetInlineEnd: 0,
        left: '50%',
        transform: 'translate(-50%, 0)',
      },
    },

    footerContainer: {
      backgroundColor: 'var(--x-bg-1)',
      width: '100%',
    },
    footer: {
      marginTop: 0,
    },
    breadcrumbContainer: {
      marginTop: 12,
      paddingLeft: 36,
    },
    listHeading: {
      color: '#121212',
      fontSize: 20,
      fontWeight: 700,
      lineHeight: '28px',
    },
    notifications: {
      top: 176,
    },
  }),
  {
    name: 'App',
  },
);

export default useStyles;
